import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Chat from '../views/Chat.vue';
import ModelPlayground from '../views/ModelPlayground.vue';
import RolePlayground from '../views/RolePlayground.vue';
import SecurePlayground from '../views/SecurePlayground.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/chat'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: { requiresAuth: true }
  },
  {
    path: '/model-playground',
    name: 'ModelPlayground',
    component: ModelPlayground,
    meta: { requiresAuth: true }
  },
  {
    path: '/role-playground',
    name: 'RolePlayground',
    component: RolePlayground,
    meta: { requiresAuth: true }
  },
  {
    path: '/secure-playground',
    name: 'SecurePlayground',
    component: SecurePlayground,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.path !== '/login' && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router; 